import { ErrorMessage } from "@hookform/error-message";
import { useFormContext } from "react-hook-form";
import __ from "../../utils/getContent";

const PasswordField = ({
	registeredName,
	label,
	placeholder,
	isRequired,
	requiredText,
	matchingFieldKey,
	onBlur,
	minLength = 0,
	confirmMatch = false,
}: {
	registeredName: string;
	label: string;
	placeholder?: string;
	isRequired: boolean;
	requiredText?: string;
	matchingFieldKey?: string;
	onBlur?: () => string | Promise<string | undefined | void>;
	minLength?: number;
	confirmMatch?: boolean;
}) => {
	const {
		register,
		getValues,
		setValue,
		setError,
		clearErrors,
		formState: { errors },
	} = useFormContext();

	// Check if the password fields match.
	function checkPasswords(value: string) {
		setValue(registeredName, value);

		const loginPass = getValues("login.password");
		const loginPassConfirm = getValues("login.passwordConfirm");

		if (confirmMatch && loginPass && loginPassConfirm) {
			const targetField = "login.password";
			if (loginPass !== loginPassConfirm) {
				setError(targetField, {
					type: "custom",
					message: __(
						"password_mismatch",
						"The passwords you have entered do not match.",
					),
				});
			} else {
				clearErrors(targetField);
			}
		}
	}

	return (
		<div className="mb-3">
			<label
				className="ml-2 block text-sm uppercase"
				htmlFor={`input-${registeredName}`}
			>
				{label}
				{isRequired && "*"}
			</label>

			{errors && (
				<p className="mb-1 ml-2 text-xs text-red-500">
					<ErrorMessage errors={errors} name={registeredName} />
				</p>
			)}
			<input
				type="password"
				id={`input-${registeredName}`}
				{...register(registeredName)}
				onChange={(e) => confirmMatch && checkPasswords(e.target.value)}
				className="w-full border border-black px-2 py-3 placeholder:uppercase"
				required={isRequired}
				minLength={minLength}
				placeholder={placeholder}
			/>
		</div>
	);
};
export default PasswordField;
